// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.show {
  visibility: visible !important;
}

.app-header {
  position: relative;
  top: 2px;
  margin-top: -2px;
}
@media (min-width: 1140px) {
  .app-header .container {
    max-width: initial !important;
  }
}
.app-header .header-banner {
  background-color: #206ead;
  background-size: 100% 100%;
  background-repeat: no-repeat;
  display: block;
  height: 120px;
  width: 100%;
}
.app-header .picture-container {
  width: 92%;
  height: 100%;
  margin: 0px 3%;
}
.app-header .logo-left {
  background-image: url('logo-header-large.svg');
  background-repeat: no-repeat;
  background-size: 100% 100%;
  height: 100%;
  width: min(45%, 250px);
  float: left;
}
.app-header .img-right {
  background-image: url('YCYV white.png');
  background-repeat: no-repeat;
  background-size: 100% auto;
  background-position: 0% 50%;
  width: min(45%, 340px);
  height: 100%;
  float: right;
}
.app-header .no-decoration {
  text-decoration: none;
}
.app-header .banner-header-text-mobile {
  display: none;
}
@media screen and (max-width: 500px) {
  .app-header .banner-header-text-mobile {
    display: table-cell;
    color: #ffffff;
    position: relative;
  }
}
.app-header .navigation-bar {
  width: 100%;
  background-color: #474747;
}
.app-header .appbar-button {
  background-color: #474747;
  border: 1px solid white;
  border-radius: 0px;
  box-shadow: none;
  color: white;
  padding: 8px 16px;
  text-transform: none;
  font-size: 0.7em;
}
.app-header .appbar-button:hover {
  background-color: white;
  border-color: white;
  color: #0f5596;
}
.app-header .k-menu:not(.k-context-menu) > .k-item {
  background-color: white;
  color: #0f5596;
  padding: 1px;
  font-size: 0.84em;
}
.app-header .k-menu:not(.k-context-menu) > .k-item:hover {
  color: #0f5596;
  background-color: white;
}
.app-header .k-menu:not(.k-context-menu) > .k-item .k-state-active {
  color: #0f5596;
}
.app-header .navbar {
  width: 100%;
  min-height: 50px;
  padding: 10px;
  margin: none;
  background-color: #474747;
}
.app-header .navbar .button-menu, .app-header .navbar .menu-container {
  width: -moz-fit-content;
  width: fit-content;
  display: inline-block;
  color: #ffffff;
}
.app-header .navbar .menu-container {
  float: right;
  padding-right: 15px;
  padding-left: 15px;
}
.app-header .navbar .nav-container {
  margin: 0;
  padding-top: 10px;
  list-style: none;
  background-color: transparent;
}
.app-header .navbar .nav-container .k-popup {
  background-color: #474747;
  padding: 10px;
}
.app-header .navbar .nav-container ul {
  list-style: none;
  margin: 0;
  padding: 0;
}
.app-header .navbar .nav-container ul li {
  margin: 10px;
}
.app-header .navbar .nav-container button {
  width: 100%;
}
@media only screen and (min-width: 900px) {
  .app-header .navbar {
    display: flex;
    flex-direction: row-reverse;
    width: -moz-fit-content;
    width: fit-content;
  }
  .app-header .navbar .button-menu {
    display: none;
  }
  .app-header .navbar .nav-container {
    padding: 0;
    display: flex;
    width: -moz-fit-content;
    width: fit-content;
  }
  .app-header .navbar .nav-container li {
    margin: 0 10px 0 10px;
  }
}
.app-header .wide-menu {
  display: none;
}
.app-header .narrow-menu {
  display: block;
}
@media screen and (min-width: 900px) {
  .app-header .narrow-menu {
    display: none;
  }
  .app-header .wide-menu {
    display: block;
  }
}`, "",{"version":3,"sources":["webpack://./src/app/shared/components/app-header/app-header.component.scss"],"names":[],"mappings":"AAAA;EACI,8BAAA;AACJ;;AACA;EAMI,kBAAA;EACA,QAAA;EACA,gBAAA;AAHJ;AAJI;EACI;IACI,6BAAA;EAMV;AACF;AACI;EACI,yBAAA;EACA,0BAAA;EACA,4BAAA;EACA,cAAA;EACA,aAAA;EACA,WAAA;AACR;AACI;EACI,UAAA;EACA,YAAA;EACA,cAAA;AACR;AACI;EACI,8CAAA;EACA,4BAAA;EACA,0BAAA;EACA,YAAA;EACA,sBAAA;EACA,WAAA;AACR;AACI;EACI,uCAAA;EACA,4BAAA;EACA,0BAAA;EACA,2BAAA;EACA,sBAAA;EACA,YAAA;EACA,YAAA;AACR;AACI;EACI,qBAAA;AACR;AAEI;EACI,aAAA;AAAR;AACQ;EAFJ;IAGQ,mBAAA;IACA,cAAA;IACA,kBAAA;EAEV;AACF;AAEI;EACI,WAAA;EACA,yBAAA;AAAR;AAEI;EACI,yBAAA;EACA,uBAAA;EACA,kBAAA;EACA,gBAAA;EACA,YAAA;EACA,iBAAA;EACA,oBAAA;EAMA,gBAAA;AALR;AAAQ;EACI,uBAAA;EACA,mBAAA;EACA,cAAA;AAEZ;AAEI;EACI,uBAAA;EACA,cAAA;EACA,YAAA;EAQA,iBAAA;AAPR;AAAQ;EACI,cAAA;EACA,uBAAA;AAEZ;AAAQ;EACI,cAAA;AAEZ;AAEI;EACI,WAAA;EACA,gBAAA;EACA,aAAA;EACA,YAAA;EACA,yBAAA;AAAR;AAEQ;EACI,uBAAA;EAAA,kBAAA;EACA,qBAAA;EACA,cAAA;AAAZ;AAGQ;EACI,YAAA;EACA,mBAAA;EACA,kBAAA;AADZ;AAIQ;EAEI,SAAA;EACA,iBAAA;EACA,gBAAA;EACA,6BAAA;AAHZ;AAKY;EACI,yBAAA;EACA,aAAA;AAHhB;AAMY;EACI,gBAAA;EACA,SAAA;EACA,UAAA;AAJhB;AAMgB;EACI,YAAA;AAJpB;AAQY;EACI,WAAA;AANhB;AAWI;EACI;IACI,aAAA;IACA,2BAAA;IACA,uBAAA;IAAA,kBAAA;EATV;EAWU;IACI,aAAA;EATd;EAYU;IACI,UAAA;IACA,aAAA;IACA,uBAAA;IAAA,kBAAA;EAVd;EAYc;IACI,qBAAA;EAVlB;AACF;AAeI;EACI,aAAA;AAbR;AAgBI;EACI,cAAA;AAdR;AAiBI;EACI;IACI,aAAA;EAfV;EAiBM;IACI,cAAA;EAfV;AACF","sourcesContent":[".show{\n    visibility:visible!important;\n}\n.app-header {\n    @media (min-width: 1140px) {\n        .container {\n            max-width: initial !important;\n        }\n    }\n    position: relative;\n    top: 2px;\n    margin-top: -2px;\n\n    // Title\n    .header-banner {\n        background-color: #206ead;\n        background-size: 100% 100%;\n        background-repeat: no-repeat;\n        display: block;\n        height: 120px;\n        width: 100%;\n    }\n    .picture-container {\n        width: 92%;\n        height: 100%;\n        margin: 0px 3%;\n    }\n    .logo-left {\n        background-image: url(../../../../assets/images/logo-header-large.svg);\n        background-repeat: no-repeat;\n        background-size: 100% 100%;\n        height: 100%;\n        width: calc(min(45%, 250px));\n        float: left;\n    }\n    .img-right {\n        background-image: url(\"../../../../assets/images/YCYV white.png\");\n        background-repeat: no-repeat;\n        background-size: 100% auto;\n        background-position: 0% 50%;\n        width: calc(min(45%, 340px));\n        height: 100%;\n        float: right;\n    }\n    .no-decoration {\n        text-decoration: none;\n    }\n\n    .banner-header-text-mobile {\n        display: none;\n        @media screen and (max-width: 500px) {\n            display: table-cell;\n            color: #ffffff;\n            position: relative;\n        }\n    }\n\n    // Navigation Bar\n    .navigation-bar{\n        width: 100%;\n        background-color: #474747;\n    }\n    .appbar-button {\n        background-color: #474747;\n        border: 1px solid white;\n        border-radius: 0px;\n        box-shadow: none;\n        color: white;\n        padding: 8px 16px;\n        text-transform: none;\n        &:hover {\n            background-color: white;\n            border-color: white;\n            color: #0f5596;\n        }\n        font-size: 0.7em;\n    }\n    .k-menu:not(.k-context-menu)>.k-item {\n        background-color: white;\n        color: #0f5596;\n        padding: 1px;\n        &:hover {\n            color: #0f5596;\n            background-color: white;\n        }\n        .k-state-active {\n            color: #0f5596;\n        }\n        font-size: 0.84em;\n    }\n    .navbar {\n        width: 100%;\n        min-height: 50px;\n        padding: 10px;\n        margin: none;\n        background-color: #474747;\n\n        .button-menu, .menu-container{\n            width: fit-content;\n            display: inline-block;\n            color: #ffffff;\n        }\n\n        .menu-container{\n            float: right;\n            padding-right: 15px;\n            padding-left: 15px;\n        }\n\n        .nav-container{\n            // width: 100%;\n            margin: 0;\n            padding-top: 10px;\n            list-style: none;\n            background-color: transparent;\n            \n            .k-popup{\n                background-color: #474747;\n                padding: 10px;\n            }\n            \n            ul{\n                list-style: none;\n                margin: 0;\n                padding: 0;\n\n                li{\n                    margin: 10px;\n                }\n            }\n\n            button{\n                width: 100%;\n            }\n        }\n    }\n\n    @media only screen and (min-width: 900px) {\n        .navbar {\n            display: flex;\n            flex-direction: row-reverse;\n            width: fit-content;\n\n            .button-menu{\n                display: none;\n            }\n\n            .nav-container{\n                padding: 0;\n                display: flex;\n                width: fit-content;\n\n                li{\n                    margin: 0 10px 0 10px;\n                }\n            }\n        }\n    }\n\n    .wide-menu {\n        display: none;\n    }\n    \n    .narrow-menu {\n        display: block;\n    }\n    \n    @media screen and (min-width: 900px) {\n        .narrow-menu {\n            display: none;\n        }\n        .wide-menu {\n            display: block;\n        }\n    }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
